<template>
  <div class="exam-mask exam-mask--overlay">
    <div
      class="exam-mask__modal"
      :class="{ 'exam-mask__modal--is-loading': loading }"
    >
      <Spinner v-if="loading" />
      <template v-else>
        <div class="actions">
          <span v-if="loadingPrint">
            <Spinner style="height: 40px; width: 40px" />
          </span>
          <button
            v-else
            class="actions__btn actions__btn--print"
            :disabled="loadingPrint || loadingDownload"
            @click="printPDF"
          >
            <md-tooltip
              class="tooltip-results-export"
              md-delay="400"
              md-direction="bottom"
            >
              Imprimir Máscara
            </md-tooltip>
            <svg-loader src="/static/images/icon-individual-print.svg" />
          </button>

          <span v-if="loadingDownload">
            <Spinner style="height: 40px; width: 40px" />
          </span>

          <button
            v-else
            class="actions__btn actions__btn--download"
            :disabled="loadingDownload || loadingPrint"
            @click="downloadPDF"
          >
            <md-tooltip
              class="tooltip-results-export"
              md-delay="400"
              md-direction="bottom"
            >
              Exportar em PDF
            </md-tooltip>
            <svg-loader src="/static/images/icon-downloads-alt.svg" />
          </button>

          <button
            class="actions__btn actions__btn--close"
            :disabled="loadingDownload || loadingPrint"
            @click="closeModal"
          >
            <svg-loader src="/static/images/icon-close-small.svg" />
          </button>
        </div>

        <div ref="printMe">
          <div
            v-if="rollbackLaudasa"
            class="exam-mask__header --rollback"
          >
            <div class="container">
              <div class="logo-and-partners">
                <img
                  class="logo-and-partners--logo"
                  src="/static/images/logo-alvaro-interna.svg"
                  alt="Laboratório Alvaro"
                />
              </div>
            </div>
            <div class="exam-data container space-on-top">
              <div class="exam-data__left-side">
                <div>
                  <span class="label-rollback">Nome paciente</span>
                  <p class="value-rollback">Nome do paciente</p>
                </div>

                <div class="space-on-top">
                  <span class="label-rollback">Nome social</span>
                  <p class="value-rollback">Nome Social do paciente</p>
                </div>

                <div class="space-on-top">
                  <span class="label-rollback">Data de Nascimento</span>
                  <p class="value-rollback">00/00/0000</p>
                </div>

                <div class="space-on-top">
                  <span class="label-rollback">Solicitante</span>
                  <p class="value-rollback">Médico solicitante</p>
                </div>

                <div class="space-on-top">
                  <span class="label-rollback">Instituição</span>
                  <p class="value-rollback">Nome da instituição</p>
                </div>
              </div>

              <div class="exam-data__right-side">
                <div class="flex-between space-on-top">
                  <div>
                    <span class="label-rollback">Documento</span>
                    <p class="value-rollback">000.000.000-00</p>
                  </div>
                  <div class="gender">
                    <span class="label-rollback">Sexo</span>
                    <p class="value-rollback">X</p>
                  </div>
                  <div class="fixed-width">
                    <span class="label-rollback">Data de Emissão</span>
                    <p class="value-rollback">XX/XX/XXXX XX:XX:XX</p>
                  </div>
                </div>

                <div class="flex-between space-on-top">
                  <div>
                    <span class="label-rollback">Ordem de Serviço</span>
                    <p class="value-rollback">XXXXXXXXXX</p>
                  </div>

                  <div class="fixed-width">
                    <span class="label-rollback">Data de Cadastro</span>
                    <p class="value-rollback">XX/XX/XXXX XX:XX:XX</p>
                  </div>
                </div>

                <div class="flex-between space-on-top">
                  <div>
                    <span class="label-rollback">Cadastro LIS</span>
                    <p class="value-rollback">XXXXXXX</p>
                  </div>

                  <div class="fixed-width">
                    <span class="label-rollback">Ordem Serviço LIS</span>
                    <p class="value-rollback">XXXXXXXXXXXX</p>
                  </div>
                </div>

                <div class="space-on-top">
                  <span class="label-rollback">Local</span>
                  <p class="value-rollback">Local de Execução</p>
                  <p>Detalhes sobre a amostra</p>
                </div>
              </div>
            </div>
            <hr class="divider" />
          </div>

          <div
            v-else
            class="exam-mask__header"
          >
            <div class="container">
              <div class="logo-and-partners">
                <img
                  class="logo-and-partners--logo"
                  src="/static/images/logo-alvaro-interna.svg"
                  alt="Laboratório Alvaro"
                />
                <img
                  class="logo-and-partners--partners flex-between"
                  src="/static/images/exam-mask/apoio-parceiros.png"
                  alt="Acreditação e Controles de Qualidade"
                />
              </div>
              <div class="lab-info">
                <div class="lab-info__branding flex-between">
                  <p class="flex-between--same-size">NOME DO SEU LABORATÓRIO</p>
                  <p class="flex-between--same-size">Unidade:</p>
                </div>
                <p class="lab-info__sample-info">
                  Amostra coletada, identificada e enviada pelo lab. associado
                </p>
              </div>
            </div>
            <hr class="divider" />
            <div class="exam-data container">
              <div class="flex-between">
                <p class="patient-name">Nome do paciente - 000000000</p>
                <div class="fap">
                  FAP:
                  <span>000000000000</span>
                </div>
              </div>
              <div class="exam-data__details flex-between">
                <div class="flex-2">
                  <div class="flex-items-inline">
                    <p class="label">
                      DN:
                      <span>XX/XX/XXXX | 00 anos e 0 meses</span>
                    </p>
                    <p class="label">
                      Sexo:
                      <span>Sexo do paciente</span>
                    </p>
                  </div>

                  <div class="flex-items-inline">
                    <p class="label">
                      Médico:
                      <span>Nome do médico</span>
                    </p>
                    <p class="label">
                      CRM:
                      <span>XX-00000</span>
                    </p>
                  </div>
                  <p class="label">
                    Solicitante:
                    <span>Nome do médico solicitante</span>
                  </p>
                </div>

                <div>
                  <p class="label">
                    OS:
                    <span>Ordem de serviço</span>
                  </p>
                  <p class="label">
                    OS Lis:
                    <span>0000000000000</span>
                  </p>
                  <p class="label">
                    Registro Lis:
                    <span>0000000000000</span>
                  </p>
                  <p class="label">
                    CPF:
                    <span>000.000.000-00</span>
                  </p>
                </div>
              </div>

              <div class="exam-data__dates flex-between">
                <p>
                  Data Coleta:
                  <br />
                  <span class="date">00/00/0000 00:00</span>
                </p>

                <p>
                  Data de Registro:
                  <br />
                  <span class="date">00/00/0000 00:00</span>
                </p>

                <p>
                  Data Emissao:
                  <br />
                  <span class="date">00/00/0000 00:00</span>
                </p>
              </div>
            </div>
            <hr class="divider" />
          </div>

          <div
            class="exam-mask__body"
            :class="{ '--rollback': rollbackLaudasa }"
          >
            <div v-if="!rollbackLaudasa">
              <div class="default-measure container">
                <div class="default-measure__values">
                  <svg-loader src="/static/images/exam-mask/check.svg" />
                  Dentro do intervalo de referência
                </div>
                <div class="default-measure__values">
                  <svg-loader src="/static/images/exam-mask/arrow-down.svg" />
                  Abaixo do intervalo de referência
                </div>
                <div class="default-measure__values">
                  <svg-loader src="/static/images/exam-mask/arrow-up.svg" />
                  Acima do intervalo de referência
                </div>
              </div>
              <p class="measure-label">Legenda aplicável para valores numéricos</p>

              <hr class="divider" />
            </div>

            <div class="reference-values">
              <div class="container">
                <p
                  :class="{ rollback: rollbackLaudasa }"
                  class="reference-values__exam-name flex-between--same-size"
                >
                  {{ exam.name }}
                </p>
              </div>

              <div
                v-if="isNewApiFormat"
                class="container"
              >
                <template v-if="getSelectedNtoCriticisms.length > 0">
                  <div class="new-api-format">
                    <div class="criticism-headers">
                      <div class="header-col">Linhas de Resultado</div>
                      <div class="header-col">Resultado | Unidade de Medida</div>
                      <div class="header-col">Valor de Referência</div>
                    </div>
                    <div
                      v-for="(criticism, criticismIndex) in getSelectedNtoCriticisms"
                      :key="`criticism-row-${criticismIndex}-${
                        criticism.id || criticismIndex
                      }`"
                      class="criticism-row"
                    >
                      <div class="criticism-col box-copy">
                        <span>{{ criticism.name || 'N/A' }}</span>
                        <ButtonCopy :text-to-copy="criticism.name || 'N/A'" />
                      </div>
                      <div class="criticism-col box-copy">
                        <span class="value-1">XXX</span>
                        <span class="value-2">|</span>
                        <span class="value-3">{{ criticism.unitMeasure || 'N/A' }}</span>
                        <ButtonCopy :text-to-copy="criticism.unitMeasure || 'N/A'" />
                      </div>
                      <div class="criticism-col box-copy">
                        <div
                          v-if="
                            !criticism.referenceValue ||
                            criticism.referenceValue.trim() === ''
                          "
                        >
                          N/A
                        </div>
                        <div v-else>
                          <template
                            v-for="(part, index) in formatTextToArray(
                              criticism.referenceValue
                            )"
                          >
                            <span
                              v-if="part.isSpace"
                              :key="`criticism-ref-space-${criticismIndex}-${index}`"
                              class="space"
                            ></span>
                            <span
                              v-else
                              :key="`criticism-ref-text-${criticismIndex}-${index}`"
                            >
                              {{
                                part.text != null && part.text !== '' ? part.text : 'N/A'
                              }}
                            </span>
                          </template>
                        </div>
                        <ButtonCopy :text-to-copy="criticism.referenceValue || 'N/A'" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div
                v-if="!isNewApiFormat"
                class="flex-between container"
              >
                <div class="reference-values__result-line flex-between--same-size">
                  <span>Linhas de resultado</span>
                  <div
                    v-for="(line, index) in criticismsOrdered"
                    :key="`result-line-${index}-${line.id || index}`"
                    class="line box-copy"
                  >
                    {{ line.name }}
                    <ButtonCopy
                      v-if="line.name"
                      :text-to-copy="line.name"
                    />
                  </div>
                </div>
                <div class="reference-values__unity-measure">
                  <span>Resultado | Unidade de Medida</span>
                  <div
                    v-for="(measure, index) in criticismsOrdered"
                    :key="`unit-measure-${index}-${measure.id || index}`"
                    class="value box-copy"
                  >
                    <template v-if="measure.unit">
                      <span class="value-1">XXX</span>
                      <span class="value-2">|</span>
                      <span class="value-3">{{ measure.unit }}</span>
                    </template>
                    <ButtonCopy
                      v-if="measure.unit"
                      :text-to-copy="measure.unit"
                    />
                  </div>
                </div>
                <div
                  v-if="referenceValues"
                  class="reference-values__values flex-between--same-size"
                >
                  <span>Valor de referência</span>

                  <template v-if="!rollbackLaudasa && selectedNtoValues().length">
                    <div
                      v-for="(item, index) in selectedNtoValues()"
                      :key="`selected-nto-item-${index}`"
                      class="value-unified box-copy --no-uppercase"
                    >
                      <p v-html="formatResponseText(item.data.value)" />
                      <ButtonCopy
                        v-if="item.data.value"
                        :text-to-copy="item.data.value"
                      />
                    </div>
                  </template>

                  <template v-else>
                    <template v-if="!isIgnoredByExam">
                      <div
                        v-for="(itemRef, i) in referenceValues.valuesOld"
                        :key="`old-ref-value-${i}`"
                        class="value-unified box-copy --no-uppercase"
                      >
                        <p v-html="formatResponseText(itemRef.data.value)" />
                        <ButtonCopy
                          v-if="itemRef.data.value"
                          :text-to-copy="itemRef.data.value"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div
                        v-for="(itemRef, i) in referenceValues.values"
                        :key="`ref-value-${i}`"
                        class="value-unified box-copy --no-uppercase"
                      >
                        <p v-html="formatResponseText(itemRef.data.value)" />
                        <ButtonCopy
                          v-if="itemRef.data.value"
                          :text-to-copy="itemRef.data.value"
                        />
                      </div>
                    </template>
                  </template>
                </div>
              </div>
              <div
                v-if="rollbackLaudasa"
                class="container"
              >
                <p
                  class="fixed-note"
                  style="text-align: left"
                >
                  Observação / Nota Fixa: As informações neste campo serão apresentadas
                  quando estiverem disponíveis para o exame.
                </p>
              </div>
              <div class="container">
                <p
                  v-if="rollbackLaudasa"
                  style="text-align: left"
                  class="text-material"
                >
                  Material: {{ exam.materials ? exam.materials[0].name : '' }}
                </p>
                <p
                  v-else
                  class="text-material"
                >
                  (Material: {{ exam.materials ? exam.materials[0].name : '' }})
                </p>

                <p
                  v-if="rollbackLaudasa"
                  style="text-align: left"
                  class="text-method"
                >
                  Método: {{ getSelectedNtoMethodology }}
                </p>
                <p
                  v-else
                  class="text-method"
                >
                  (Método: {{ getSelectedNtoMethodology }})
                </p>
              </div>
            </div>

            <div
              v-if="!rollbackLaudasa"
              class="container"
            >
              <p class="fixed-note">
                Observação / Nota Fixa: As informações neste campo serão apresentadas
                quando estiverem disponíveis para o exame.
              </p>
            </div>

            <div class="released-by">
              <div
                v-if="!rollbackLaudasa"
                class="container"
              >
                <p
                  class="released-by__details"
                  :style="{ textAlign: rollbackLaudasa ? 'right' : '' }"
                >
                  Liberado por: Nome e número do(s) cadastro(s) no conselho do liberador
                  técnico
                  <br />
                  Responsável: Nome e número do(s) cadastro(s) no conselho do liberador
                  técnico
                </p>

                <p class="released-by--local-title">Local de Execução do exame:</p>
                <p class="released-by--local">
                  Endereço e CNES do local de execução do exame
                </p>
                <p class="released-by--exam-name">
                  {{ exam.name }}
                </p>
              </div>

              <template v-else>
                <div class="container">
                  <p
                    class="released-by__details"
                    :style="{ textAlign: rollbackLaudasa ? 'right' : '' }"
                  >
                    Liberado por: Nome e número do(s) cadastro(s) no conselho do liberador
                    técnico
                    <br />
                    Responsável: Nome e número do(s) cadastro(s) no conselho do liberador
                    técnico
                  </p>
                </div>

                <hr class="divider divider--rollback" />

                <div class="container">
                  <p
                    class="released-by--local-title"
                    style="margin-bottom: 0px"
                  >
                    Locais de execução dos exames:
                  </p>
                  <p class="released-by--local">
                    Endereço e CNES do local de execução do exame: {{ exam.name }}
                  </p>
                </div>
              </template>
            </div>
          </div>

          <div
            v-if="!rollbackLaudasa"
            class="exam-mask__footer"
          >
            <div class="attention container">
              A interpretação dos resultados deste(s) exame(s) e a conclusão diagnóstica
              são atos médicos, dependem de análise conjunta dos dados clínicos e demais
              exames do(a) paciente.
            </div>
            <div class="lab-info container">
              <div class="lab-info__wrapper">
                <div class="lab-info__date">
                  Data da geração: 00/00/0000 - 00:00
                  <br />
                  Sob a responsabilidade do Dr(a) responsável pelo laboratório - CRM nº
                  00000
                </div>
                <div class="lab-info__box">
                  Laboratório registrado no CRM/XX sob o número 000000
                  <br />
                  Licença de funcionamento 00/00/0000: Nº 00000/0000
                </div>
              </div>
            </div>

            <div class="contact container">
              <div>
                <span>Tel.:</span>
                0800-643-8100/
                <span>Site.:</span>
                www.alvaroapoio.com.br
              </div>
            </div>
          </div>
        </div>

        <iframe
          ref="pdfIframe"
          class="pdf-iframe"
          style="display: none"
        />
      </template>
    </div>
  </div>
</template>

<script>
import examGuideService from '@/api/examGuide'
import Spinner from '@/components/common/Spinner'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'
import notify from '../../../api/notification'

export default {
  name: 'ExamMask',
  components: {
    Spinner,
    ButtonCopy,
  },
  props: {
    referenceValues: {
      type: Object,
      required: true,
    },
    exam: {
      type: Object,
      required: true,
    },
    rollbackLaudasa: {
      type: Boolean,
      required: true,
    },
    isIgnoredByExam: {
      type: Boolean,
    },
    selectedNto: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    loading: false,
    resultLines: [],
    loadingDownload: false,
    loadingPrint: false,
  }),
  computed: {
    criticismsOrdered() {
      if (this.resultLines.criticisms) {
        return this.resultLines.criticisms.slice().sort((a, b) => a.position - b.position)
      }
      return []
    },

    isNewApiFormat() {
      if (!this.referenceValues) {
        return false
      }

      if (Array.isArray(this.referenceValues)) {
        return (
          this.referenceValues.length > 0 &&
          (this.referenceValues[0].dateUpdated ||
            this.referenceValues[0].methodology ||
            this.referenceValues[0].unitMeasure ||
            this.referenceValues[0].executationNto)
        )
      }

      return (
        this.referenceValues.dateUpdated ||
        this.referenceValues.methodology ||
        this.referenceValues.unitMeasure ||
        this.referenceValues.executationNto ||
        (this.referenceValues.values &&
          this.referenceValues.values.length > 0 &&
          (this.referenceValues.values[0].dateUpdated ||
            this.referenceValues.values[0].methodology ||
            this.referenceValues.values[0].unitMeasure ||
            this.referenceValues.values[0].executationNto))
      )
    },

    getSelectedNtoData() {
      if (!this.isNewApiFormat || !this.referenceValues) {
        return null
      }

      let valuesArray = this.referenceValues.values || this.referenceValues

      if (Array.isArray(this.referenceValues)) {
        valuesArray = this.referenceValues
      }

      if (!Array.isArray(valuesArray) || valuesArray.length === 0) {
        return null
      }

      if (!this.selectedNto) {
        return valuesArray[0]
      }

      const selectedNtoData = valuesArray.find(item => {
        const executionNtos = item.executationNto || item.executionNto
        if (!executionNtos) return false

        return executionNtos.some(nto => {
          return (
            nto.executationCode === this.selectedNto ||
            nto.name === this.selectedNto ||
            nto.id?.toString() === this.selectedNto?.toString() ||
            this.selectedNto === nto.executationCode ||
            this.selectedNto === nto.name
          )
        })
      })

      return selectedNtoData || valuesArray[0]
    },

    getSelectedNtoCriticisms() {
      const ntoData = this.getSelectedNtoData
      if (!ntoData || !ntoData.criticism) {
        return []
      }

      return ntoData.criticism.slice().sort((a, b) => a.position - b.position)
    },

    getSelectedNtoReferenceValue() {
      const ntoData = this.getSelectedNtoData
      if (!ntoData) {
        return ''
      }

      return ntoData.referenceValue || ''
    },

    getSelectedNtoMethodology() {
      if (this.isNewApiFormat) {
        const ntoData = this.getSelectedNtoData
        if (ntoData) {
          return ntoData.methodology || ntoData.method || 'N/A'
        }
        return 'N/A'
      }

      if (this.rollbackLaudasa) {
        if (
          this.referenceValues.valuesOld &&
          this.referenceValues.valuesOld.length &&
          this.referenceValues.valuesOld[0].data
        ) {
          return this.referenceValues.valuesOld[0].data.method || 'N/A'
        }
        return 'N/A'
      } else {
        if (
          this.selectedNto &&
          this.selectedNtoValues().length &&
          this.selectedNtoValues()[0].data
        ) {
          return this.selectedNtoValues()[0].data.method || 'N/A'
        }

        if (this.referenceValues.valuesOld && this.referenceValues.valuesOld.length) {
          const firstValue = this.referenceValues.valuesOld[0]
          return (
            firstValue.methodology || (firstValue.data && firstValue.data.method) || 'N/A'
          )
        }
        return 'N/A'
      }
    },
  },
  mounted() {
    this.getResultLines()
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    formatResponseText(text) {
      return text.replace(/\n/g, '<span class="space"></span>')
    },
    formatTextToArray(text, character = '\n') {
      if (!text || text.trim() === '') return [{ text: 'N/A', isSpace: false }]

      const parts = []
      const splitChar = character || '\n'
      const segments = text.split(splitChar)

      segments.forEach((segment, index) => {
        if (segment) {
          parts.push({ text: segment, isSpace: false })
        }
        if (index < segments.length - 1) {
          parts.push({ text: '', isSpace: true })
        }
      })

      return parts.length > 0 ? parts : [{ text: 'N/A', isSpace: false }]
    },
    getResultLines() {
      this.loading = true
      examGuideService
        .getIntegrationParams(this.exam.code)
        .then(response => {
          this.loading = false
          this.resultLines = response.data
        })
        .catch(err => {
          this.loading = false
          console.error(err.response.data.message)
        })
    },
    async handlePDF(action) {
      try {
        if (action === 'download') this.loadingDownload = true
        if (action === 'print') this.loadingPrint = true
        const element = this.$refs.printMe
        const canvas = await html2canvas(element, { scale: 1.5 })
        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF('p', 'mm', 'a4')
        const pageWidth = pdf.internal.pageSize.getWidth()
        const pageHeight = pdf.internal.pageSize.getHeight()
        const verticalMargin = 5
        const imgWidth = pageWidth
        const imgProps = pdf.getImageProperties(imgData)
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width
        const usablePageHeight = pageHeight - 2 * verticalMargin
        const totalPages = Math.ceil(imgHeight / usablePageHeight)

        for (let page = 0; page < totalPages; page++) {
          if (page > 0) pdf.addPage()
          const sY = (page * usablePageHeight * imgProps.height) / imgHeight
          const sHeight = (usablePageHeight * imgProps.height) / imgHeight
          const pageCanvas = document.createElement('canvas')
          pageCanvas.width = imgProps.width
          pageCanvas.height = sHeight
          const ctx = pageCanvas.getContext('2d')
          const image = new window.Image()
          image.src = imgData
          await new Promise(resolve => {
            image.onload = () => {
              ctx.drawImage(
                image,
                0,
                sY,
                imgProps.width,
                sHeight,
                0,
                0,
                imgProps.width,
                sHeight
              )
              resolve()
            }
          })
          const pageImgData = pageCanvas.toDataURL('image/png')
          pdf.addImage(pageImgData, 'PNG', 0, verticalMargin, imgWidth, usablePageHeight)
        }

        if (action === 'download') {
          pdf.save(`${this.exam.code} - Máscara.pdf`)
        } else if (action === 'print') {
          const pdfUrl = pdf.output('bloburl')
          let oldIframe = document.getElementById('print-pdf-iframe')
          if (oldIframe) {
            document.body.removeChild(oldIframe)
          }
          const iframe = document.createElement('iframe')
          iframe.style.display = 'none'
          iframe.id = 'print-pdf-iframe'
          document.body.appendChild(iframe)
          iframe.onload = () => {
            setTimeout(() => {
              try {
                iframe.contentWindow.focus()
                iframe.contentWindow.print()
              } catch (e) {
                notify({
                  title: 'AVISO:',
                  message: 'Não foi possível imprimir automaticamente.',
                })
              }
            }, 500)
          }
          iframe.contentWindow?.addEventListener('afterprint', () => {
            document.body.removeChild(iframe)
          })
          iframe.src = pdfUrl
        }
      } catch (e) {
        notify({
          title: 'AVISO:',
          message: 'Não foi possível imprimir automaticamente.',
        })
      } finally {
        setTimeout(() => {
          if (action === 'download') this.loadingDownload = false
        }, 3000)
        if (action === 'print') this.loadingPrint = false
      }
    },
    printPDF() {
      this.handlePDF('print')
    },
    downloadPDF() {
      this.handlePDF('download')
    },
    selectedNtoValues() {
      if (this.isNewApiFormat) {
        return []
      }

      if (
        !this.referenceValues ||
        !this.referenceValues.values ||
        !this.referenceValues.values.length
      ) {
        return []
      }

      return this.referenceValues.values.filter(nto => {
        return (
          nto &&
          nto.executionNto &&
          typeof nto.executionNto === 'string' &&
          nto.executionNto.includes &&
          this.selectedNto &&
          nto.executionNto.includes(this.selectedNto)
        )
      })
    },
  },
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/mascara-de-laudo.css';

.exam-mask {
  &--overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.54);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
  }

  &__modal {
    background-color: #fff;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 400;
    color: #000;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 95%;
    max-width: 1000px;
    height: 98vh;
    padding: 70px 0 0;
    border-radius: 12px;
    position: relative;
    overflow-x: auto;

    &--is-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
  }

  .box-copy {
    position: relative;

    &:hover {
      background: rgba(0, 0, 0, 0.34);

      &:not(.value-unified) {
        button {
          width: 20px;
          height: 20px;
          left: 6px;

          img {
            width: 14px;
          }
        }
      }

      button {
        opacity: 1;
        display: block;
      }

      &.value-unified {
        button {
          width: 32px;
          height: 32px;
          top: 9px;
        }
      }
    }

    button {
      position: absolute;
    }
  }
}

.new-api-format {
  width: 100%;
  max-width: 100%;
  margin-top: 10px;
  overflow-x: auto;

  .criticism-headers {
    display: flex;
    background-color: #f5f5f5;
    padding: 8px 4px;
    border-radius: 4px;
    margin-bottom: 4px;

    .header-col {
      flex: 1;
      font-size: 9px;
      font-weight: bold;
      text-align: center;
      padding: 0 4px;
      text-transform: uppercase;
      color: #4f4f4f;

      &:first-child {
        flex: 0 0 40%;
      }

      &:nth-child(2) {
        flex: 0 0 19%;
      }

      &:last-child {
        flex: 1;
      }
    }
  }

  .criticism-row {
    display: flex;
    margin-bottom: 4px;

    .criticism-col {
      background: #f8f5f2;
      padding: 8px;
      border-radius: 4px;
      margin: 0 2px;
      font-size: 9px;
      font-weight: bold;
      color: #4f4f4f;
      position: relative;
      align-items: center;
      justify-content: center;
      text-align: center;
      min-height: 30px;

      &:first-child {
        flex: 0 0 40%;
      }

      &:nth-child(2) {
        flex: 0 0 18%;
      }

      &:last-child {
        flex: 1;
        text-align: left;
        justify-content: flex-start;
        align-items: flex-start;
        word-wrap: break-word;
        word-break: break-word;
        white-space: normal;
        line-height: 1.3;

        div {
          width: 100%;
        }
      }

      .value-1,
      .value-2,
      .value-3 {
        display: inline;
      }

      .value-2 {
        margin: 0 4px;
      }

      .space {
        display: block;
        padding: 2px 0;
      }

      button {
        position: absolute;
        top: 2px;
        right: 2px;
      }
    }
  }
}
</style>
